function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.703,
    height: 46,
    viewBox: "0 0 37.703 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M86.005,149.544a.966.966,0,0,0-.684-.452,7.083,7.083,0,0,1-1.133-13.659,1.018,1.018,0,0,0,.627-1.269,1.032,1.032,0,0,0-.106-.235A11.326,11.326,0,0,0,76.553,128a15.415,15.415,0,0,0-5.075,1.132,11.845,11.845,0,0,1-3.645.886,11.845,11.845,0,0,1-3.645-.886A15.415,15.415,0,0,0,59.113,128c-3.618,0-10.657,5.343-10.657,15.138,0,9.309,6.518,21.194,11.626,21.194a11.959,11.959,0,0,0,5.619-1.348,5.165,5.165,0,0,1,2.132-.67,5.166,5.166,0,0,1,2.132.67,11.959,11.959,0,0,0,5.619,1.348c4.05,0,8.621-7.242,10.535-13.953A1.046,1.046,0,0,0,86.005,149.544Z",
    transform: "translate(-48.456 -118.331)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M241.261,9.668A8.872,8.872,0,0,0,250.123.806.806.806,0,0,0,249.317,0a8.872,8.872,0,0,0-8.862,8.862A.806.806,0,0,0,241.261,9.668Z",
    transform: "translate(-221.706)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.cd9ee46e1814254dc78774c1f35c29f8.svg";
export { ForwardRef as ReactComponent };